import React from 'react';
import ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import App from './App.js';
import { SnackBarProvider } from './components/FlowBuilder/Common/SnackBar/index.tsx';
import { StyledEngineProvider } from '@mui/material/styles';

// frontend\machadalo\src\components\FlowBuilder\Common\SnackBar\index.tsx
// ReactDOM.createRoot(document.getElementById("root")).render(
//   <Router>
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   </Router>
// );
createRoot(document.getElementById('root')).render(
  <Router>
    <SnackBarProvider>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </SnackBarProvider>
  </Router>
);
// Register service worker
registerServiceWorker();
